import { render } from "./FormHelp.vue?vue&type=template&id=04bbe155"
import script from "./FormHelp.vue?vue&type=script&lang=js"
export * from "./FormHelp.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/DataForm/FormHelp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "04bbe155"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04bbe155', __exports__)) {
    console.log('reload')
    api.reload('04bbe155', __exports__)
  }
  
  module.hot.accept("./FormHelp.vue?vue&type=template&id=04bbe155", () => {
    console.log('re-render')
    api.rerender('04bbe155', render)
  })

}


export default __exports__